import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import { Vue, Component, Watch } from 'vue-property-decorator';
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue';
import { showErrors, showNotification } from '@/utils/snack';
import { SnackType } from '@/interfaces/snack';
import AppTextField from '@/components/AppTextField.vue';
import AppFormItem from '@/components/AppFormItem.vue';
import AppListSelector from '@/components/AppListSelector.vue';
import AppSimpleDistrictSelector from '@/components/AppSimpleDistrictSelector.vue';
import AppSelector from '@/components/AppSelector.vue';
import { updateOrderAddress, findOrder, findSchools } from './gql';
import AppDialog from '@/components/AppDialog.vue';
Component.registerHooks(['beforeRouteLeave']);

var Editgoods = /*#__PURE__*/function (_Vue) {
  _inherits(Editgoods, _Vue);

  var _super = _createSuper(Editgoods);

  function Editgoods() {
    var _this;

    _classCallCheck(this, Editgoods);

    _this = _super.apply(this, arguments);
    _this.breadcrumbs = [{
      text: '订单管理'
    }, {
      text: '订单',
      to: {
        name: 'OrderList'
      }
    }];
    _this.order = null;
    _this.orderInput = {
      area: null,
      schoolIdx: -1,
      schoolName: '',
      year: '',
      className: '',
      realName: '',
      phone: ''
    };
    _this.isEdit = false;
    _this.activeTab = 0;
    _this.orderId = '';
    _this.editOrderName = '';
    _this.hint = {
      text: '',
      color: ''
    };
    _this.disabledActions = false;
    _this.isLeave = false;
    _this.schoolOptions = [];
    _this.saveDialog = {
      title: '已认真核对并更新该订单的收货地址？',
      show: false,
      text: ''
    };
    return _this;
  }

  _createClass(Editgoods, [{
    key: "onAreaChange",
    value: function onAreaChange(val) {
      if (!val) {
        this.hint.text = '请选择地区';
        this.hint.color = 'red';
      } else {
        this.hint = {
          text: '',
          color: ''
        };
        this.getSchoolOptions();
      }
    }
  }, {
    key: "mounted",
    value: function () {
      var _mounted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var type;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                type = sessionStorage.getItem('type');

                if (!type) {
                  _context.next = 6;
                  break;
                }

                _context.next = 4;
                return this.initData(type);

              case 4:
                _context.next = 9;
                break;

              case 6:
                sessionStorage.setItem('type', this.$route.params.type);
                _context.next = 9;
                return this.initData(this.$route.params.type);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function mounted() {
        return _mounted.apply(this, arguments);
      }

      return mounted;
    }()
  }, {
    key: "initData",
    value: function () {
      var _initData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(type) {
        var id;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(type === 'new')) {
                  _context2.next = 5;
                  break;
                }

                this.isEdit = false;
                this.breadcrumbs.push({
                  text: '添加学校'
                });
                _context2.next = 10;
                break;

              case 5:
                this.isEdit = true;
                id = this.$route.params.id;
                this.orderId = id;
                _context2.next = 10;
                return this.getOrderById();

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function initData(_x) {
        return _initData.apply(this, arguments);
      }

      return initData;
    }()
  }, {
    key: "getOrderById",
    value: function () {
      var _getOrderById = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var result, _result$data$findOrde, mailingAddress, orderNumber, area, addrArr, schoolName, typedError;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.$apollo.query({
                  query: findOrder,
                  variables: {
                    orderId: +this.orderId
                  }
                });

              case 3:
                result = _context3.sent;

                if (result) {
                  this.order = result.data.findOrder;
                  _result$data$findOrde = result.data.findOrder, mailingAddress = _result$data$findOrde.mailingAddress, orderNumber = _result$data$findOrde.orderNumber, area = _result$data$findOrde.area;
                  addrArr = mailingAddress.split('-');
                  schoolName = addrArr[1];
                  this.orderInput = {
                    area: area,
                    schoolName: schoolName,
                    year: addrArr[2].substr(0, 4),
                    className: addrArr[3].substr(0, 1),
                    realName: addrArr[4],
                    phone: addrArr[5]
                  };
                  this.breadcrumbs = [{
                    text: '订单管理'
                  }, {
                    text: '订单',
                    to: {
                      name: 'OrderList'
                    }
                  }];
                  this.breadcrumbs.push({
                    text: "".concat(orderNumber)
                  });
                }

                _context3.next = 11;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);
                typedError = _context3.t0;
                showErrors(typedError.graphQLErrors);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function getOrderById() {
        return _getOrderById.apply(this, arguments);
      }

      return getOrderById;
    }()
  }, {
    key: "getSchoolOptions",
    value: function () {
      var _getSchoolOptions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _this2 = this;

        var result, typedError;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.orderInput.area) {
                  _context4.next = 3;
                  break;
                }

                this.schoolOptions = [];
                return _context4.abrupt("return");

              case 3:
                _context4.prev = 3;
                _context4.next = 6;
                return this.$apollo.query({
                  query: findSchools,
                  variables: {
                    paging: {
                      skip: 0,
                      take: 10000
                    },
                    where: {
                      areaId: +this.orderInput.area.id
                    }
                  }
                });

              case 6:
                result = _context4.sent;

                if (result.data.findSchools) {
                  this.schoolOptions = result.data.findSchools.schools.map(function (option) {
                    return {
                      id: +option.id,
                      label: option.name
                    };
                  });
                  this.orderInput.schoolIdx = this.schoolOptions.findIndex(function (item) {
                    var _this2$order;

                    return item.id === ((_this2$order = _this2.order) === null || _this2$order === void 0 ? void 0 : _this2$order.schoolId);
                  });
                }

                _context4.next = 14;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](3);
                typedError = _context4.t0;
                showErrors(typedError.graphQLErrors);

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[3, 10]]);
      }));

      function getSchoolOptions() {
        return _getSchoolOptions.apply(this, arguments);
      }

      return getSchoolOptions;
    }()
  }, {
    key: "clearForm",
    value: function clearForm() {
      this.orderInput = {
        area: null,
        name: '',
        dealerArea: null,
        dealerIds: []
      };
    }
  }, {
    key: "submitBasic",
    value: function () {
      var _submitBasic = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.editOrderRequest();

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function submitBasic() {
        return _submitBasic.apply(this, arguments);
      }

      return submitBasic;
    }()
  }, {
    key: "editOrderRequest",
    value: function () {
      var _editOrderRequest = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _this$orderInput, area, schoolIdx, year, className, realName, phone, school, mailingAddress, result, typedError;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!this.validateForm('form')) {
                  _context6.next = 15;
                  break;
                }

                _this$orderInput = this.orderInput, area = _this$orderInput.area, schoolIdx = _this$orderInput.schoolIdx, year = _this$orderInput.year, className = _this$orderInput.className, realName = _this$orderInput.realName, phone = _this$orderInput.phone;
                school = this.schoolOptions[schoolIdx];
                mailingAddress = "".concat(area.mergerName, "-").concat(school.label, "-").concat(year, "\u5E74\u5165\u5B66-").concat(className, "\u73ED-").concat(realName, "-").concat(phone);
                _context6.prev = 4;
                _context6.next = 7;
                return this.$apollo.mutate({
                  mutation: updateOrderAddress,
                  variables: {
                    orderId: +this.orderId,
                    mailingAddress: mailingAddress,
                    schoolId: +school.id,
                    areaId: +area.id
                  }
                });

              case 7:
                result = _context6.sent;

                if (result) {
                  showNotification({
                    msg: '更新订单地址成功！',
                    type: SnackType.Success
                  });
                  this.isEdit = true;
                  sessionStorage.setItem('type', 'edit');
                  this.disabledActions = true;
                  this.$router.go(-1);
                } else {
                  showNotification({
                    msg: '更新订单地址失败！',
                    type: SnackType.Error
                  });
                }

                _context6.next = 15;
                break;

              case 11:
                _context6.prev = 11;
                _context6.t0 = _context6["catch"](4);
                typedError = _context6.t0;
                showErrors(typedError.graphQLErrors);

              case 15:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[4, 11]]);
      }));

      function editOrderRequest() {
        return _editOrderRequest.apply(this, arguments);
      }

      return editOrderRequest;
    }()
  }, {
    key: "resetValidation",
    value: function resetValidation(form) {
      this.$refs[form].resetValidation();
    }
  }, {
    key: "validateForm",
    value: function validateForm(form) {
      return this.$refs[form].validate();
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      if (!this.disabledActions) {
        this.saveDialog.show = true;
      }

      sessionStorage.removeItem('type');
    }
  }, {
    key: "beforeRouteLeave",
    value: function () {
      var _beforeRouteLeave = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(to, from, next) {
        var res;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!this.disabledActions) {
                  res = confirm('页面修改尚未保存，是否确定要离开？');
                  next(res);
                } else {
                  next();
                }

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function beforeRouteLeave(_x2, _x3, _x4) {
        return _beforeRouteLeave.apply(this, arguments);
      }

      return beforeRouteLeave;
    }()
  }]);

  return Editgoods;
}(Vue);

__decorate([Watch('orderInput.area', {
  deep: true,
  immediate: true
})], Editgoods.prototype, "onAreaChange", null);

Editgoods = __decorate([Component({
  components: {
    AppBreadcrumbs: AppBreadcrumbs,
    AppTextField: AppTextField,
    AppFormItem: AppFormItem,
    AppListSelector: AppListSelector,
    AppSimpleDistrictSelector: AppSimpleDistrictSelector,
    AppSelector: AppSelector,
    AppDialog: AppDialog
  }
})], Editgoods);
export default Editgoods;